import { axios } from '../../utilities/axiosClient'
import { Journal } from '../../types/Journal'

type JournalType = {
  journals: Journal[]
}

export const getMypageJournal = (): Promise<JournalType> =>
  axios.get('/api/mypage/journal')
